import axios, {AxiosResponse} from 'axios'
import {Prescription} from '@interfaces/prescription'
import wcs from '@libs/wcs'

export const getRxData = async ({
  storeId = '',
  productUpc='',
  }:{
  storeId?: string,
  productUpc?: string,
}):Promise<AxiosResponse<any> | null> => {
  try {
    return await axios
      .get(
        `/wcs/resources/store/${storeId}/rox/lensesData/${productUpc}`
      )
  } catch (error) {
    console.error('get rx data api error:', error)
    return null
  }

}

export const getPrescription = async ({storeId,prescriptionId}:{storeId:string,prescriptionId:string}):Promise<AxiosResponse<Prescription> | null> => {
  try {
    return await axios
      .get(
        `/wcs/resources/store/${storeId}/prescription/${prescriptionId}`
      )
  } catch (error) {
    console.error('get prescription api error:', error)
    return null
  }
}

export const uploadPrescriptionFile = async ({
  storeId,
  fileData,
  fileName,
  userId,
  orderId,
}: {
  storeId: string,
  fileData: any,
  fileName: string,
  userId?: number | string,
  orderId?: string | number,
}): Promise<
  AxiosResponse<{
    prescriptionId: string
  }>
> => {
  try {
    const params = {
        fileData,
        fileName,
        userId,
        orderId,
    }
    const domain = wcs.getEnvConfig('currentDomain') || ''
    return await axios
      .post(`${domain}/wcs/resources/store/${storeId}/sgh/prescription/file`,params)
  } catch (error) {
    console.error('upload prescription file api error:', error)
    if (error instanceof Error) {
      throw new Error(error.message)
    } else {
      throw new Error('upload prescription file api error:')
    }
  }
}


export const deletePrescription = async ({
  storeId,
  lensOrderItemId,
}: {
  storeId: string,
  lensOrderItemId: string
}): Promise<AxiosResponse<any>> => {
  try {
    const params = {
      storeId,
      lensOrderItemId,
    }
    const domain = wcs.getEnvConfig('currentDomain') || ''
    return await axios.put(
      `${domain}/wcs/resources/store/${storeId}/prescription/order/${lensOrderItemId}`
    )
  } catch (error) {
    console.error('delete prescription api error:', error)
    if (error instanceof Error) {
      throw new Error(error.message)
    } else {
      throw new Error('delete prescription api error')
    }
  }
}
